"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AlternateTextForReCaptcha = void 0;
var styled_1 = __importDefault(require("@emotion/styled"));
var react_1 = __importDefault(require("react"));
var styles_1 = require("../../../styles");
var StyledWrapper = styled_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  font-size: 12px;\n  line-height: 1.7;\n  color: #959597;\n  @media (", ") {\n    text-align: center;\n  }\n  > a {\n    color: #5891dc;\n  }\n"], ["\n  font-size: 12px;\n  line-height: 1.7;\n  color: #959597;\n  @media (", ") {\n    text-align: center;\n  }\n  > a {\n    color: #5891dc;\n  }\n"])), styles_1.BREAKPOINTS.smallAndUp);
var AlternateTextForReCaptcha = function (_a) {
    var className = _a.className;
    return (react_1.default.createElement(StyledWrapper, { className: className },
        "reCAPTCHA \u3067\u4FDD\u8B77\u3055\u308C\u3066\u3044\u307E\u3059",
        ' ',
        react_1.default.createElement("a", { href: "https://policies.google.com/privacy", target: "_blank", rel: "noreferrer" }, "\u30D7\u30E9\u30A4\u30D0\u30B7\u30FC"),
        ' ',
        "-",
        ' ',
        react_1.default.createElement("a", { href: "https://policies.google.com/terms", target: "_blank", rel: "noreferrer" }, "\u5229\u7528\u898F\u7D04")));
};
exports.AlternateTextForReCaptcha = AlternateTextForReCaptcha;
var templateObject_1;
